module.exports = __webpack_public_path__ + "img/undraw_everywhere_together_bdmn.21322257.svg";